<template>
  <div class="site-list" @click.stop>
    <slot name="siteLink"></slot>
    <Transition name="slide-fade">
      <div v-if="isShow" class="site-list-wrapper"  :style="{ width: selectedSubDomain ? '700px' : reportView !== 'none' ? '600px' : '400px' }">
        <div class="url-list domain" :class="{on: onPanel === 0}" @mouseenter="onPanel=0">
          <div class="url-type-name">{{ $t('common.domain') }}</div>
          <ul class="url-list-wrapper">
            <li class="url-item" v-for="item in computedDomainList" :key="item.sid" @click="selectDomain(item)">
              <div class="url-wrap" :class="{active: selectedDomain.sid === item.sid}">
                <span class="title ellipsis"><span class="matchType">[{{ item.matchType }}]</span> {{ item.domain | domain }}</span>
                <template v-if="reportView !== 'none'">
                  <i class="icon icon--arrow-right-medium-black size-14"></i>
                </template>
                <template v-else>
                  <i class="toggle icon icon--check-white-size14 size-14"></i>
                </template>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="selectedDomain && reportView !== 'none'" class="url-list sub-domain" :class="{on: onPanel === 1}" @mouseenter="onPanel=1">
          <div class="url-type-name">
            {{ $t('common.subDomain') }}
            <span class="icon icon--info-outline-white" v-btf-tooltip:top="{ contents: $t('subdomain.tooltip'), size: 220 }"></span>
          </div>
          <ul class="url-list-wrapper" ref="subListRef">
            <template v-if="domain.shared !== 'shared' && userData.userId !== 'samsung_gmc'">
              <li class="url-item"  @click="selectSubDomain(null)">
                <div class="url-wrap" :class="{active: !selectedSubDomain}">
                  <span class="title ellipsis">{{ $t('common.allDomain') }}</span>
                  <i class="toggle icon icon--check-white-size14"></i>
                </div>
              </li>
            </template>
            <li class="url-item" v-for="sub in selectedDomain.subDomains" :key="sub.orgSid" @click="selectSubDomain(sub)">
              <div class="url-wrap" :class="{active: selectedSubDomain && selectedSubDomain.domain === sub.domain}">
                <i v-if="domain.shared !== 'shared'" class="icon icon--enter size-16"></i>
                <span class="title ellipsis">{{ sub.domain | domain }}</span>
                <i v-if="sub.firstPaths.length > 0" class="icon icon--arrow-right-medium-black size-14"></i>
                <i v-else class="toggle icon icon--check-white-size14 size-14"></i>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="selectedSubDomain && selectedSubDomain.firstPaths.length > 0  && reportView !== 'none'" class="url-list first-path" :class="{on: onPanel === 2}" @mouseenter="onPanel=2">
          <div v-if="selectedSubDomain.firstPaths.length > 0" class="search-input">
            <input type="text" v-model="searchText" :placeholder="$t('firstPath.searchDefault')" @input="searchPath">
            <i class="icon icon--search size-12"></i>
          </div>
          <div class="url-type-name">
            {{ $t('common.firstPath') }}
            <span class="icon icon--info-outline-white" v-btf-tooltip:top="{ contents: $t('firstPath.tooltip'), size: 220}"></span>
          </div>
          <template v-if="setPathList.length > 0">
            <ul class="url-list-wrapper">
              <template v-if="userData.userId !== 'samsung_gmc'">
                <li class="url-item" v-if="!searchText" @click="selectFirstPath(null)">
                  <div class="url-wrap" :class="{active: selectedFirstPath === null}">
                    <span class="title ellipsis">{{ $t('firstPath.allPath')}}</span>
                    <i class="toggle icon icon--check-white-size14 size-14"></i>
                  </div>
                </li>
              </template>
              <li class="url-item" v-for="path in setPathList" :key="path"  @click="selectFirstPath(path)">
                <div class="url-wrap" :class="{active: (selectedFirstPath || selectedFirstPath === '') && selectedFirstPath === path}">
                  <i class="icon icon--enter size-16"></i>
                  <span v-if="!!path" class="title path-name ellipsis" v-html="matchedText(path)"></span>
                  <span v-else class="title path-name-none ellipsis" v-html="matchedText(path)"></span>
                  <i class="toggle icon icon--check-white-size14 size-14"></i>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="no-data">
              <i class="icon icon--empty"></i>
              <span>{{ $t('common.noResult') }}</span>
            </div>
          </template>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SiteListSelector',
  props: {
    domainList: {
      type: Array,
      default: null
    },
    reportView: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      onPanel: 0,
      isShow: false,
      selectedDomain: null,
      selectedSubDomain: null,
      selectedFirstPath: null,
      searchedList: [],
      searchText: ''
    }
  },
  computed: {
    ...mapState([
      'userData',
      'domain',
      'journeyOptions'
    ]),
    setPathList () {
      return this.searchText.length > 0 ? this.searchedList : this.selectedSubDomain.firstPaths
    },
    computedDomainList () {
      if (this.userData.userId === 'admin' && this.reportView !== 'mine') {
        return this.domainList.filter(item => item.orgSid !== '56e7142775')
      }
      return this.domainList
    }
  },
  watch: {
    value () {
      this.isShow = this.value
    }
  },
  mounted () {
    this.selectedDomain = this.domainList.find(item => {
      return item.orgSid === this.journeyOptions.sid || item.sid === this.journeyOptions.sid
    }) || this.domainList[0]
    if (this.reportView !== 'none' && this.journeyOptions.subDomain) {
      this.selectedSubDomain = this.selectedDomain.subDomains.find(item => item.domain === this.journeyOptions.subDomain)
      this.selectedFirstPath = this.journeyOptions.firstPath
    } else {
      this.selectedSubDomain = null
      this.selectedFirstPath = null
    }
  },
  methods: {
    selectDomain (target) {
      this.selectedDomain = target
      this.selectedSubDomain = null

      if (!this.selectedDomain.existSubdomains || this.reportView === 'none') {
        this.setDomain()
      }
    },
    selectSubDomain (target) {
      this.selectedSubDomain = target
      if (!target) {
        this.setDomain()
      } else if (target.firstPaths.length === 0) {
        this.selectFirstPath(null)
      }
      this.searchText = ''
    },
    selectFirstPath (target) {
      this.selectedFirstPath = target
      this.setSubDomain()
    },
    setDomain () {
      this.$emit('set-domain', {
        sid: this.selectedDomain.orgSid || this.selectedDomain.sid,
        domain: this.selectedDomain.domain,
        domainData: this.selectedDomain
      })
    },
    setSubDomain () {
      this.$emit('set-domain', {
        sid: this.selectedSubDomain.orgSid || this.selectedSubDomain.sid,
        domain: this.selectedSubDomain.domain,
        domainData: this.selectedSubDomain,
        firstPath: this.selectedFirstPath,
        isSubDomain: true
      })
    },
    searchPath () {
      this.searchedList = this.selectedSubDomain.firstPaths.filter(path => path.match(this.searchText))
    },
    matchedText (text) {
      return text.replace(this.searchText, `<span class="match-text">${this.searchText}</span>`)
    }
  }
}
</script>

<style lang="scss" scoped>

.site-list {
  position: relative;
  z-index: 9999;
  .site-list-wrapper {
    position: absolute;
    top: 100%;
    left: 16px;
    margin-top: 10px;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 30px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);;
    }

    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 16px 15px -4px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    display: flex;
    box-sizing: border-box;
    .url-list {
      display: flex;
      flex-direction: column;
      width: 300px;
      height: 346px;
      border-right: 1px solid #ccc;
      min-width: 160px;
      flex-grow: 0;
      transition: all 500ms ease;
      box-sizing: border-box;
      overflow: hidden;

      position: relative;
      &:not(:hover) {
        width: 200px;
      }
      &.on {
        flex-grow: 1;
      }
      &:last-child {
        border: 0;
      }
      .url-type-name {
        display: flex;
        align-items: center;
        height: 68px;
        gap: 5px;
        font-size: 13px;
        color: $brandColor;
        padding: 17px 20px 32px;
        box-sizing: border-box;
        flex-shrink: 0;
      }
      &-wrapper {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 10px;
        .url-item {
          padding: 8px 10px;
          .url-wrap {
            cursor: pointer;
            font-size: 14px;
            padding: 5px 10px;
            border-radius: 12px;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 5px;
            .title {
              display: inline-block;
              width: 100%;

              .matchType {
                text-transform: capitalize;
              }
            }
            i.icon:not(.icon--enter) {
              display: none;
            }
            &:hover {
              background-color: #ebebeb;
              i.icon:not(.toggle) {
                display: inline-block;
              }
            }
            &.active {
                background-color: #ec0047;
                color: #ffffff;
                i.icon:not(.toggle):not(.icon--enter) {
                  background: url('../../assets/img/common/icon--arrow-small-right-white.svg');
                  display: inline-block;
                }
                i.toggle {
                  display: inline-block;
                }
                i.icon--enter {
                  background: url('../../assets/img/common/icon--enter-white.svg');
                }
              }
          }
        }
      }
      .no-data {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        i {
          display: inline-block;
          margin-bottom: 10px;
        }
        span {
          display: block;
          color: #2F2F2F;
          font-size: 14px;
          line-height: 1.5;
        }

      }
      .search-input {
        position: absolute;
        top: 10px;
        right: 10px;
        border: 1px solid #bbb;
        border-radius: 6px;
        padding: 8px 10px;
        input {
          transition: all 500ms ease;
          border: 0;
          padding: 0;
          width: 0;
        }
      }
      &.on {
        .search-input  {
          input {
            width: 115px;
          }
        }
      }
      &.first-path {
        .url-item {
          .title.path-name {
            span.match {
              font-weight: bold;
              color: $brandColor;
            }
            &:before, &:after {content: '/';}
          }
          .title.path-name-none {
            span.match {
              font-weight: bold;
              color: $brandColor;
            }
            &:before {content: '/';}
          }
        }
      }
    }
  }
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease, top 0.5s ease;
  transition-delay: 0.2s;
  z-index: 1;
}
.slide-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease, top 0.3s ease;
  z-index: 1;
}

.slide-fade-enter,
.slide-fade-leave-to {
  top: calc(50% - 30px);
  opacity: 0;
  // transform: translate(-50%, -50%);
}
</style>
